module.exports = __webpack_public_path__ + "img/c03.d8917c16.png";